import type { MarketingNote } from '../../../../api/venue-marketing';

import { NoteTextForm } from './NoteTextForm';

interface NoteBodyProps {
  note: MarketingNote;
  editing: boolean;
  busy: boolean;
  onCancel: () => void;
  onSave: (body: string) => void;
}

/** A note's text, shown as plain text (never markup), or the editor for it. */
export function NoteBody({ note, editing, busy, onCancel, onSave }: NoteBodyProps) {
  if (editing) {
    return (
      <div style={{ marginTop: 6 }}>
        <NoteTextForm
          initial={note.body}
          label="Edit note text"
          submitLabel="Save"
          busy={busy}
          onCancel={onCancel}
          onSubmit={onSave}
          autoFocus
        />
      </div>
    );
  }
  return (
    <p
      style={{
        margin: '4px 0 0',
        fontSize: 12.5,
        lineHeight: 1.5,
        color: 'var(--nb-ink)',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere',
      }}
    >
      {note.body}
    </p>
  );
}
